import { z } from 'zod';

/**
 * AI Assistant (header): the owner's choice of 2026-10-24 is a read-only lookup with no outside
 * AI. It recognises identifiers and the reference's suggestions and answers from this
 * application's own data, within the caller's hierarchy and permissions.
 */

/**
 * The reference's suggestion chips, less "Unsubscribe report": this application keeps no
 * list of unsubscribed customers.
 */
export const ASSISTANT_SUGGESTIONS = [
  'Free SIMs',
  'Inventory breakdown',
  'Check invoice',
  'Find customer',
  'Activations',
  'Port-in today',
  'Active customers',
] as const;

export const assistantAskSchema = z.object({
  question: z.string().trim().min(1, 'Type a question').max(500),
});
export type AssistantAskInput = z.input<typeof assistantAskSchema>;

export interface AssistantAnswerDto {
  question: string;
  /** What the answer is about, e.g. "Customer 100123". */
  title: string;
  facts: Array<{ label: string; value: string }>;
  /** Pages of this application the answer points to. */
  links: Array<{ label: string; to: string }>;
  /** Said when nothing was found, a permission is missing or the question was not understood. */
  note: string | null;
}
